import { Injectable } from '@angular/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import { Preferences } from '@capacitor/preferences';
import { Observable, defer } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class SecureStorageService {
    constructor() {
        this.checkFirstLaunch();
    }

    private async checkFirstLaunch() {
        const { value } = await Preferences.get({ key: 'firstLaunchOccurred' });
        if (!value) {
            await SecureStorage.clear();
            await Preferences.set({ key: 'firstLaunchOccurred', value: 'true' });
        }
    }
    setItem(key: string, value: string): Observable<void> {
        return defer(() => SecureStorage.setItem(key, value));
    }
    getItem(key: string): Observable<string | null> {
        return defer(() => SecureStorage.getItem(key));
    }
    removeItem(key: string): Observable<void> {
        return defer(() => SecureStorage.removeItem(key));
    }
}
